import { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  adminJwtClient,
  adminJwtClientFile,
} from "@/apps/admin-console/services/apiClient/apiClient";
import { ADMIN_ACCOUNTS_API_URLS as apiUrl } from "@/apps/admin-console/services/apiClient/apiUrl";
import { IAdminAccount } from "@/apps/admin-console/models/IAdminAccount";

export const getAdminAccount = (
  adminAccountId: string
): Promise<AxiosResponse> => {
  return adminJwtClient.get(apiUrl(adminAccountId).GET);
};

export const updateAdminAccount = (
  adminAccountId: string,
  adminAccount: IAdminAccount
): Promise<AxiosResponse> => {
  return adminJwtClient.put(apiUrl(adminAccountId).UPDATE, {
    adminAccount: adminAccount,
  });
};

export const updateAdminAccountApiKey = (
  adminAccountId: string
): Promise<AxiosResponse> => {
  return adminJwtClient.put(apiUrl(adminAccountId).UPDATE_API_KEY);
};

export const storeDefaultPricing = (
  adminAccountId: string,
  data: FormData,
  config: AxiosRequestConfig
): Promise<AxiosResponse> => {
  return adminJwtClientFile.post(
    apiUrl(adminAccountId).STORE_DEFAULT_PRICING,
    data,
    config
  );
};

export const getCatalogAndPricing = (
  adminAccountId: string,
  config: AxiosRequestConfig
): Promise<AxiosResponse> => {
  return adminJwtClient.get(
    apiUrl(adminAccountId).GET_CATALOG_AND_PRICING,
    config
  );
};
